import { render } from "./IconContainer.vue?vue&type=template&id=3d316554"
import script from "./IconContainer.vue?vue&type=script&lang=ts"
export * from "./IconContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script